module.exports = __webpack_public_path__ + "static/media/fondo2.a9715213.jpg";